"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Histogram = exports.defaultBuckets = void 0;
var Collector_1 = require("./Collector");
var Timer_1 = require("./Timer");
var utils_1 = require("./utils");
exports.defaultBuckets = Object.freeze([
    0.005,
    0.01,
    0.025,
    0.05,
    0.075,
    0.1,
    0.25,
    0.5,
    0.75,
    1,
    2.5,
    5,
    7.5,
    10,
]);
var Histogram = (function (_super) {
    __extends(Histogram, _super);
    function Histogram(config) {
        var _this = _super.call(this, config) || this;
        _this.type = 'histogram';
        _this.buckets = exports.defaultBuckets;
        _this.bucketValueMap = {};
        _this.timers = {};
        if (config.labels) {
            for (var _i = 0, _a = config.labels; _i < _a.length; _i++) {
                var label = _a[_i];
                if (label === 'le') {
                    throw new Error('Invalid label name: `le`');
                }
            }
        }
        if (config.buckets) {
            _this.buckets = config.buckets;
        }
        return _this;
    }
    Histogram.prototype.createInitialBucketMap = function () {
        var bucketMap = {};
        for (var _i = 0, _a = this.buckets; _i < _a.length; _i++) {
            var b = _a[_i];
            bucketMap["".concat(b)] = 0;
        }
        return bucketMap;
    };
    Histogram.prototype.createInitialBucketValue = function () {
        return {
            labelMap: {},
            bucketMap: this.createInitialBucketMap(),
            sum: 0,
            count: 0,
        };
    };
    Histogram.prototype.getBucketByValue = function (v) {
        for (var _i = 0, _a = this.buckets; _i < _a.length; _i++) {
            var bucket = _a[_i];
            if (v <= bucket) {
                return bucket;
            }
        }
        return -1;
    };
    Histogram.prototype.validateLabels = function (labels) {
        for (var _i = 0, labels_1 = labels; _i < labels_1.length; _i++) {
            var label = labels_1[_i];
            if (!this.labels.includes(label)) {
                throw new Error("Invalid label: ".concat(label));
            }
        }
    };
    Histogram.prototype.reset = function () {
        this.bucketValueMap = {};
    };
    Histogram.prototype.observe = function (v, labelMap) {
        if (labelMap) {
            this.validateLabels(Object.keys(labelMap));
        }
        if (!Number.isFinite(v)) {
            throw new Error("Invalid Histogram value: ".concat(v));
        }
        var key = labelMap ? (0, utils_1.hashLabelMap)(labelMap) : '';
        var bucketValue = this.bucketValueMap[key];
        if (!bucketValue) {
            bucketValue = this.createInitialBucketValue();
            this.bucketValueMap[key] = bucketValue;
        }
        bucketValue.sum = bucketValue.sum + v;
        bucketValue.count = bucketValue.count + 1;
        if (labelMap) {
            bucketValue.labelMap = labelMap;
        }
        var targetBucket = this.getBucketByValue(v);
        if (Number.isFinite(bucketValue.bucketMap[targetBucket])) {
            bucketValue.bucketMap[targetBucket] += 1;
        }
    };
    Histogram.prototype.startTimer = function (labelMap) {
        var start = Date.now();
        var key = labelMap ? (0, utils_1.hashLabelMap)(labelMap) : '';
        var timer = new Timer_1.Timer({ histogram: this, start: start, labelMap: labelMap });
        this.timers[key] = timer;
        return timer;
    };
    Histogram.prototype.collect = function () {
        var samples = [];
        var bucketValues = Object.values(this.bucketValueMap);
        for (var _i = 0, bucketValues_1 = bucketValues; _i < bucketValues_1.length; _i++) {
            var bucketValue = bucketValues_1[_i];
            var total = 0;
            for (var _a = 0, _b = this.buckets; _a < _b.length; _a++) {
                var bucket = _b[_a];
                total += bucketValue.bucketMap[bucket];
                samples.push({
                    labels: __assign(__assign({}, bucketValue.labelMap), { le: "".concat(bucket) }),
                    value: total,
                    name: "".concat(this.name, "_bucket"),
                });
            }
            samples.push.apply(samples, [
                {
                    labels: __assign(__assign({}, bucketValue.labelMap), { le: '+Inf' }),
                    value: bucketValue.count,
                    name: "".concat(this.name, "_bucket"),
                },
                {
                    labels: bucketValue.labelMap,
                    value: bucketValue.sum,
                    name: "".concat(this.name, "_sum"),
                },
                {
                    labels: bucketValue.labelMap,
                    value: bucketValue.count,
                    name: "".concat(this.name, "_count"),
                },
            ]);
        }
        return samples;
    };
    return Histogram;
}(Collector_1.Collector));
exports.Histogram = Histogram;
//# sourceMappingURL=Histogram.js.map